import React__default from 'react';
import { Row, Col } from '@sravni/react-design-system/lib/Grid';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useStyles } from '@sravni/react-utils';
import { AgreementCheckbox } from '../../../AgreementCheckbox/view.js';
import { GetOTPButton } from '../../../GetOTPButton/view.js';
import { PhoneInput } from '../../../PhoneInput/view.js';
import { ServerErrorMessage } from '../../../ServerErrorMessage/view.js';
import modules_13b53a7e from '../../styles.module.less.js';

const PhoneScreen = (props) => {
    const { title, subTitle, onGetOTPClick } = props;
    const cx = useStyles(modules_13b53a7e);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Heading, { level: 3, className: cx('title') }, title),
        React__default.createElement(Text, { size: 14, className: cx('subTitle') }, subTitle),
        React__default.createElement(Row, { className: cx('fields'), gutter: [0, 24] },
            React__default.createElement(Col, { span: 12 },
                React__default.createElement(PhoneInput, null)),
            React__default.createElement(Col, { span: 12 },
                React__default.createElement(GetOTPButton, { size: 52, className: cx('submitButton'), onClick: onGetOTPClick, additionalValidationFields: ["agreement" /* FIELD_NAME.AGREEMENT */] }, "\u0412\u043E\u0439\u0442\u0438")),
            React__default.createElement(Col, { span: 12 },
                React__default.createElement(AgreementCheckbox, null)),
            React__default.createElement(ServerErrorMessage, { className: cx('serverError') }))));
};

export { PhoneScreen };
//# sourceMappingURL=index.js.map
